import { RaciRole, RaciAssignment } from '@/types/common';

export const getRaciColor = (role: RaciRole): string => {
  const colors: Record<RaciRole, string> = {
    RESPONSIBLE: '#1890ff',
    ACCOUNTABLE: '#52c41a',
    CONSULTED: '#faad14',
    INFORMED: '#d9d9d9',
  };
  return colors[role];
};

export const getRaciLabel = (role: RaciRole): string => {
  const labels: Record<RaciRole, string> = {
    RESPONSIBLE: 'R',
    ACCOUNTABLE: 'A',
    CONSULTED: 'C',
    INFORMED: 'I',
  };
  return labels[role];
};

export const getRaciDescription = (role: RaciRole): string => {
  const descriptions: Record<RaciRole, string> = {
    RESPONSIBLE: 'Responsible for doing the work',
    ACCOUNTABLE: 'Accountable for the outcome',
    CONSULTED: 'Consulted for input',
    INFORMED: 'Informed of progress',
  };
  return descriptions[role];
};

export const filterByRaciRole = (
  assignments: RaciAssignment[],
  role: RaciRole,
): RaciAssignment[] => {
  return assignments.filter((a) => a.role === role);
};

export const getUsersByRole = (
  assignments: RaciAssignment[],
  role: RaciRole,
): string[] => {
  return assignments.filter((a) => a.role === role).map((a) => a.userName);
};

// --- New RACI type helpers for matrix grid ---

export type RaciTypeCode = 'R' | 'A' | 'C' | 'I';

export const getRaciTypeColor = (type: RaciTypeCode): string => {
  const colors: Record<RaciTypeCode, string> = {
    R: '#ff4d4f',
    A: '#faad14',
    C: '#52c41a',
    I: '#1890ff',
  };
  return colors[type] || '#d9d9d9';
};

export const getRaciTypeBgColor = (type: RaciTypeCode): string => {
  // Translucent tints of each RACI accent colour so cells read correctly on
  // both light and dark backgrounds (hardcoded near-white tints looked like
  // light patches in dark mode).
  const colors: Record<RaciTypeCode, string> = {
    R: 'rgba(255, 77, 79, 0.14)',   // red
    A: 'rgba(250, 173, 20, 0.16)',  // amber
    C: 'rgba(82, 196, 26, 0.14)',   // green
    I: 'rgba(24, 144, 255, 0.14)',  // blue
  };
  return colors[type] || 'transparent';
};

export const getRaciTypeLabel = (type: RaciTypeCode): string => {
  const labels: Record<RaciTypeCode, string> = {
    R: 'Responsible',
    A: 'Accountable',
    C: 'Consulted',
    I: 'Informed',
  };
  return labels[type] || '';
};
